import React from 'react';
import styled from 'styled-components';
import { colors, sizes } from 'styles/variables';

export default props => {
	const StyledWrapper = styled.div`
		display: block;
		font-size: 0.9em;
		border-radius: 99px;
		font-weight: 600;
		cursor: pointer;
		text-transform: capitalize;
		${Number(props.type) === 1 &&
			`
			background: ${colors[props.hue].base};
			color:${colors.background[0]};
			border:2px solid ${colors[props.hue].base};
			padding: ${sizes[2]} ${sizes[3]};
			text-align:center;
		`};
		${Number(props.type) === 2 &&
			`
			background: transparent;
			color:${colors[props.hue].base};
			border:2px solid ${colors[props.hue].base};
			padding: ${sizes[2]} ${sizes[3]};
			text-align:center;
		`};
		&:hover {
			filter: brightness(1.1);
		}
	`;
	return <StyledWrapper>{props.title}</StyledWrapper>;
};
